import React, { Component } from 'react';
import PerimetreContext from '../../contexts/PerimetreContext';
import { EUIPage } from '../EUI/EUIPage';

export class ADV extends Component {

    static contextType = PerimetreContext;

    render = () => <EUIPage
        baseUrl="/ADV"
        onglets={[
            { url: "/AppelsDeFonds", titre: "Appels de fonds" },
            { url: "/Echeanciers", titre: "Échéanciers", disabled: !this.context.perimetre.idOperation }
        ]}
    />;

}